export const articles = [
  {
    slug: 'brand-philosophy-water',
    title: '以水为名：幼水若若的品牌哲学',
    excerpt: '水是生命之源，也是最柔软却最坚韧的力量。探索幼水若若如何从水的智慧中汲取灵感，创造温和有效的护肤之道。',
    content: `## 水的智慧

水，无形却有万形。它可以是最温柔的存在——清晨叶片上的露珠，山间缓缓流淌的溪流；也可以是最坚韧的力量——滴水穿石，惊涛拍岸。这种"以柔克刚"的智慧，正是幼水若若品牌哲学的核心。

## 诞生于自然的灵感

幼水若若的创始团队在一次山间旅行中获得了灵感。清晨，他们看到山泉从岩石缝隙中缓缓渗出，水质清澈见底，触感温润如丝。那一刻，他们意识到：真正的护肤，不应是强力改造，而应是如水般温和滋养，让肌肤回归最自然的状态。

## 幼水若若的四大品牌理念

**柔润滋养**——如同春日细雨滋润大地，我们的产品以温和的方式渗透肌肤，在不知不觉中改善肤质。

**纯净本真**——精选天然植萃成分，摒弃不必要的化学添加，每一款产品都经得起成分的审视。

**以柔克刚**——不追求立竿见影的强效刺激，而是通过持续的温和呵护，让肌肤从内而外焕发健康光泽。

**回归自然**——倡导简约护肤哲学，相信少即是多，让肌肤在自然节奏中找到平衡。

## 水的护肤力量

科学研究表明，肌肤的水分含量直接影响其健康状态。充足的水分能让肌肤饱满有弹性，减少细纹产生。幼水若若全系列产品以"水"为核心，通过不同形态的水润呵护——从洁面到精华，从面霜到面膜——构建完整的水润护肤体系。

我们相信，最好的护肤不是改变你的肌肤，而是让肌肤做回它自己——如幼水般纯净、柔软、充满生命力。`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20serene%20natural%20landscape%20with%20a%20clear%20mountain%20stream%20flowing%20over%20smooth%20rocks%2C%20soft%20morning%20light%20filtering%20through%20trees%2C%20mist%20rising%20from%20the%20water%2C%20peaceful%20and%20contemplative%20atmosphere%2C%20Zen-inspired%20nature%20photography%20with%20warm%20tones&width=1200&height=600&seq=article-001&orientation=landscape',
    category: '品牌故事',
    author: '幼水若若编辑部',
    date: '2026-07-15',
    readTime: '8分钟',
  },
  {
    slug: 'skincare-guide-spring',
    title: '春日护肤指南：让肌肤如幼水般柔润焕新',
    excerpt: '春季是肌肤换季的关键时期，如何在这个季节做好温和护理？幼水若若为你带来春日护肤的完整方案。',
    content: `## 春季护肤的挑战

春季气温回升，但气候变化无常，肌肤也进入了敏感高发期。干燥、泛红、起皮……这些换季困扰，其实都可以通过正确的护肤方式来缓解。

## 春季护肤"三温"法则

**温水洁面**——春季肌肤屏障较为脆弱，建议使用35°C左右的温水洁面，避免过热或过冷的水刺激肌肤。搭配若若氨基酸洁面乳，温和清洁不伤肤。

**温润补水**——春季补水的关键在于"润"而非"湿"。选择含有玻尿酸、玫瑰纯露等成分的精华水，采用轻拍+按压的方式让肌肤充分吸收。推荐若若柔肤精华水，轻透质地带给肌肤第一道水润。

**温柔防护**——春季紫外线已经开始增强，防晒不可忽视。幼水轻盈防晒乳的水感质地非常适合春季使用，轻薄不闷，SPF50+的防护力足够应对日常通勤。

## 春季护肤小贴士

1. **循序渐进更换护肤品**——不要一次性替换所有护肤品，给肌肤适应的时间
2. **加强面膜护理**——每周2-3次保湿面膜，帮助肌肤度过换季期
3. **注意饮食调理**——多喝水，多吃富含维生素C的水果蔬菜
4. **保证充足睡眠**——春季容易春困，充足睡眠是最好的护肤品

## 推荐春日护肤流程

早晨：氨基酸洁面 → 柔肤精华水 → 修护精华液 → 轻盈防晒乳
晚间：清透卸妆油 → 氨基酸洁面 → 柔肤精华水 → 修护精华液 → 润养面霜`,
    coverImage: 'https://readdy.ai/api/search-image?query=Spring%20skincare%20flat%20lay%20with%20minimalist%20bottles%20and%20jars%20on%20a%20soft%20pink%20background%2C%20cherry%20blossom%20branches%20decorating%20the%20edges%2C%20warm%20spring%20sunlight%2C%20fresh%20and%20feminine%20aesthetic%2C%20lifestyle%20photography&width=1200&height=600&seq=article-002&orientation=landscape',
    category: '护肤指南',
    author: '幼水若若护肤顾问',
    date: '2026-06-28',
    readTime: '6分钟',
  },
  {
    slug: 'ingredient-deep-dive-ceramide',
    title: '成分深解：神经酰胺——肌肤屏障的守护者',
    excerpt: '为什么神经酰胺被称为"肌肤水泥"？深入了解这个明星成分如何在幼水若若的产品中发挥修护作用。',
    content: `## 什么是神经酰胺？

神经酰胺是存在于人体皮肤角质层中的天然脂质，占角质层脂质的50%以上。它就像是砌墙时的"水泥"，将角质细胞（"砖块"）紧密连接在一起，形成完整的肌肤屏障。

## 为什么需要补充神经酰胺？

随着年龄增长和外界环境的影响（紫外线、污染、不当护肤等），肌肤中的神经酰胺会逐渐流失。当神经酰胺不足时，肌肤屏障就会出现"裂缝"——水分流失加速，外界刺激物更容易侵入，导致干燥、敏感、泛红等问题。

## 幼水若若中的神经酰胺应用

在若若润养面霜中，我们选用与人体皮肤结构高度相似的神经酰胺3型（Ceramide NP），搭配乳木果油和角鲨烷，形成"仿生屏障修护体系"：

- **神经酰胺**：填补角质层缝隙，重建屏障结构
- **乳木果油**：提供丰富脂肪酸，滋养干燥肌肤
- **角鲨烷**：形成锁水保护膜，减少水分流失

三种成分协同作用，让修护效果更加显著。

## 谁最需要神经酰胺？

- 干性肌肤和极干性肌肤
- 敏感肌和屏障受损肌肤
- 熟龄肌肤（天然神经酰胺流失较多）
- 经常使用酸类产品的人群
- 生活在干燥或寒冷气候中的人群

## 使用小贴士

建议在精华液之后、防晒之前使用含有神经酰胺的面霜。取适量于掌心温热后，从面部中央向外轻柔涂抹，帮助产品更好地吸收。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Scientific%20abstract%20representation%20of%20skin%20barrier%20with%20hexagonal%20patterns%20in%20warm%20beige%20and%20cream%20tones%2C%20droplets%20of%20liquid%20forming%20protective%20layer%2C%20clean%20and%20minimalist%20scientific%20aesthetic%2C%20soft%20lighting%2C%20biomedical-inspired%20visual&width=1200&height=600&seq=article-003&orientation=landscape',
    category: '成分揭秘',
    author: '幼水若若研发团队',
    date: '2026-06-10',
    readTime: '7分钟',
  },
  {
    slug: 'minimalist-skincare-routine',
    title: '极简护肤：少即是多的水润哲学',
    excerpt: '护肤品不是用得越多越好。幼水若若倡导极简护肤理念，教你用最少的产品实现最佳的护肤效果。',
    content: `## 极简护肤的兴起

在信息爆炸的时代，"护肤焦虑"成为了许多人的困扰。面对琳琅满目的产品和复杂的护肤步骤，我们是否忘记了护肤的初心？极简护肤（Skinimalism）正是对这种焦虑的回应——回归本质，用最少的步骤实现肌肤的健康。

## 幼水若若的极简护肤体系

我们提倡"清洁-水润-防护"三步核心护肤法：

**第一步：温和清洁**
选择氨基酸洁面产品，早晚各一次即可。过度清洁会破坏肌肤屏障，适得其反。

**第二步：精准水润**
根据当天的肌肤状态选择水润产品。日常可用柔肤精华水+修护精华液组合；感觉干燥时增加润养面霜；需要急救时使用保湿面膜。

**第三步：日间防护**
白天出门前必须做好防晒，这是最有效的抗老手段。幼水轻盈防晒乳轻薄水润，可作为日常通勤的最后一步。

## 极简不等于敷衍

极简护肤的核心是"精准"而非"省略"。关键在于：
- 了解自己的肤质
- 选择真正有效的成分
- 坚持而非频繁更换产品
- 配合健康的生活方式

## 一周极简护肤计划

| 时段 | 周一至周五 | 周末 |
|------|-----------|------|
| 日间 | 洁面 → 精华水 → 防晒 | 洁面 → 精华水 → 精华液 → 防晒 |
| 晚间 | 卸妆 → 洁面 → 精华水 → 面霜 | 卸妆 → 洁面 → 精华水 → 面膜 → 面霜 |

护肤不是比赛，不需要追求繁复的步骤。找到适合自己的节奏，让肌肤在简单中获得真正的滋养。`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20minimalist%20bathroom%20vanity%20with%20only%20three%20elegant%20skincare%20bottles%20on%20a%20marble%20tray%2C%20a%20small%20white%20towel%2C%20morning%20sunlight%20streaming%20through%20a%20window%2C%20clean%20and%20serene%20atmosphere%2C%20Scandinavian-inspired%20interior&width=1200&height=600&seq=article-004&orientation=landscape',
    category: '护肤哲学',
    author: '幼水若若编辑部',
    date: '2026-05-22',
    readTime: '5分钟',
  },
  {
    slug: 'summer-water-skincare',
    title: '夏日"以水养肤"全攻略',
    excerpt: '炎热夏季，肌肤出油缺水怎么办？幼水若若教你如何用"以水养肤"的方法，保持一整夏的水润清爽。',
    content: `## 夏季护肤的误区

很多人认为夏季护肤只需要控油。这是一个常见的误区。事实上，夏季高温会导致肌肤水分加速流失，出油往往是肌肤缺水的信号。越控油可能越出油，正确的方法应该是——以水养肤。

## "以水养肤"的核心

"以水养肤"是幼水若若针对夏季提出的护肤理念，核心在于：
- 用水的力量平衡肌肤水油
- 选择水感质地的产品避免油腻
- 通过补水来减少肌肤过度出油

## 夏季护肤四步走

**晨间清爽洁面**——使用若若氨基酸洁面乳，温水洁面，唤醒肌肤。

**日间随身补水**——幼水舒缓喷雾是夏季必备。妆前打底、午后补水、空调房加湿，一瓶搞定。

**夜间深层水润**——晚间是肌肤修复的黄金时间。卸妆后用幼水修护精华液，搭配若若保湿面膜（每周2-3次）。

**全天候防晒**——无论晴雨，防晒不可少。幼水轻盈防晒乳质地轻薄，补涂也不会有厚重感。

## 夏季饮食补水

除了外用产品，内在补水同样重要：
- 每天保证1.5-2升的饮水量
- 多食用西瓜、黄瓜、番茄等高水分蔬果
- 适当饮用绿豆汤、菊花茶等清热饮品
- 减少辛辣、油炸食物的摄入`,
    coverImage: 'https://readdy.ai/api/search-image?query=Summer%20vibes%20with%20a%20facial%20mist%20spray%20in%20front%20of%20a%20pool%2C%20water%20droplets%20in%20the%20air%2C%20green%20tropical%20leaves%2C%20bright%20sunlight%2C%20refreshing%20and%20cool%20atmosphere%2C%20lifestyle%20photography%20with%20vibrant%20colors&width=1200&height=600&seq=article-005&orientation=landscape',
    category: '护肤指南',
    author: '幼水若若护肤顾问',
    date: '2026-05-08',
    readTime: '6分钟',
  },
  {
    slug: 'founder-story',
    title: '创始人手记：从一滴水开始的品牌旅程',
    excerpt: '幼水若若创始人为你讲述品牌背后的故事——那个在山间清晨被一滴露水打动的瞬间，如何变成今天你所看到的幼水若若。',
    content: `## 那个清晨

三年前的春天，我独自一人去到云南的一座茶山。清晨五点，露水还挂在茶叶尖上，阳光从云层缝隙中洒下来，整个山谷笼罩在一层薄薄的雾气中。

我蹲下来，看着一颗露珠从茶叶上滑落。它那么小，那么轻，但它确确实实地滋润了它经过的每一寸叶面。那一刻我突然意识到——这不就是护肤的终极意义吗？

不需要轰轰烈烈的改造，只需要像水一样，温柔地、持续地、深入地滋养。

## 从一滴水到一个品牌

回到城市后，我开始研究护肤行业。我发现太多品牌在强调"强力"、"速效"、"焕肤"，仿佛肌肤是敌人，需要被"攻克"。

但肌肤不是敌人，它是我们身体最忠实的伙伴。它需要的不是战争，而是温柔的对话。

于是，幼水若若诞生了。

## 为什么叫"幼水若若"？

"幼"代表纯净与新生，"水"是我们的核心哲学，"若若"则是我们希望每个使用者都能感受到的状态——柔软、自在、不设防。

若若之柔，不是软弱，而是一种以柔克刚的力量。就像水，看似柔软，却能穿石。

## 我们的坚持

从第一款产品上市至今，我们始终坚持：
- 每一款产品上市前至少经过200人次的测试
- 配方经过至少12个月的稳定性和安全性评估
- 优先选用可追溯来源的天然植萃成分
- 包装采用可回收材料，减少环境负担

## 写在最后

幼水若若还很年轻，我们还有很多路要走。但我们会始终记住那个清晨，那滴露水，以及那份"温柔就是力量"的初心。

感谢你选择幼水若若，让我们一起，以柔克刚，如幼水般温润流淌。`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20tea%20plantation%20at%20sunrise%20with%20morning%20dew%20on%20tea%20leaves%2C%20soft%20mist%20over%20the%20hills%2C%20warm%20golden%20sunlight%20breaking%20through%2C%20peaceful%20and%20inspirational%20landscape%2C%20Yunnan%20style%20tea%20mountain%20photography&width=1200&height=600&seq=article-006&orientation=landscape',
    category: '品牌故事',
    author: '幼水若若创始人 · 林若溪',
    date: '2026-04-15',
    readTime: '10分钟',
  },
];

export const articleCategories = [
  { slug: 'all', name: '全部文章' },
  { slug: 'brand-story', name: '品牌故事' },
  { slug: 'skincare-guide', name: '护肤指南' },
  { slug: 'ingredient-deep-dive', name: '成分揭秘' },
  { slug: 'skincare-philosophy', name: '护肤哲学' },
];